








































import { computed, defineComponent, onMounted, PropType, ref } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getElement } from "@/lib/elementHelpers";
import ContentFeedBaseView from "./components/ContentFeedBaseView";
import ContentFeedUnlockFeed from "./components/ContentFeedUnlockFeed";
import ContentFeedVideoGallery from "./components/ContentFeedVideoGallery";

export default defineComponent({
  name: "ContentFeedItem",
  components: {
    ContentFeedVideoGallery,
    ContentFeedBaseView,
    ContentFeedUnlockFeed,
  },
  props: {
    contentFeed: { type: Object as PropType<ContentFeed>, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
    showFollowButton: { type: Boolean, default: false },
    showReportItem: { type: Boolean, default: true },
    showComment: { type: Boolean, default: true },
    showReview: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    showShare: { type: Boolean, default: true },
    showPrice: { type: Boolean, default: true },
    showContentSales: { type: Boolean, default: false },
    pinnedPostId: { type: String as PropType<string | null>, default: null },
    enablePinPost: { type: Boolean, default: false },
    isFollowedUser: { type: Boolean },
    previewMode: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { authUser } = useAuthUser();
    const contentFeedItem = ref();

    const isAuthor = computed(() => !!authUser.value && props.contentFeed.userId === authUser.value.id);
    const isFreePost = computed(() => {
      return props.contentFeed.pricePackageId === "0" && props.contentFeed.subscriptionLevelId === "0";
    });

    const accessed = computed(() => isAuthor.value || props.contentFeed.purchased || isFreePost.value);

    const showContentFeedUnlock = computed(() => {
      return !isAuthor.value && !props.contentFeed.user.disabled && !props.contentFeed.purchased;
    });

    onMounted(() => emit("mounted", getElement(contentFeedItem.value)));

    return {
      contentFeedItem,
      showContentFeedUnlock,
      isAuthor,
      accessed,
    };
  },
});
